import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import SubjectRightsManagementImage from './SubjectRightsManagementImage'

const copy = {
  overline: `Subject Rights Management`,
  heading: `Streamline regulatory compliance and consent management`,
  description0: (
    <>
      Accelerate compliance with regulations like the GDPR and the CCPA with automated data subject rights management to
      find a single source of truth for end-user consent with our built-in consent enforcement. Integrate with any
      consent management platform to{` `}
      <a href="https://segment.com/docs/privacy/consent-management/consent-in-segment-connections/">
        respect end user consent
      </a>
      {` `}
      across your Connections.
    </>
  ),
  description1: `Whether your customers want you to delete or modify their data, or even stop collecting it entirely, Segment has you covered.`,
}
const link = {
  text: `Explore Privacy`,
  url: `/product/privacy-portal/`,
}

const StreamlineYourRegulatoryCompliance = () => {
  const pageConfig = usePageConfig()

  return (
    <StyledSectionBase variant="2Col" copyVariant="narrow">
      <StyledSectionCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Overline>{copy.overline}</CopyText.Overline>
          <CopyText.Heading>{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description0}</CopyText.Description>
          <CopyText.Description>{copy.description1}</CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </StyledSectionCopy>
      <Section.Contents>
        <SubjectRightsManagementImage />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
  justify-self: end;
`

export default StreamlineYourRegulatoryCompliance
